import {
    BirthdayApiFp,
  BlockPersonDto,
  CreatePersonExtendedDto,
  DeletePersonDto,
  EditPersonExtendedDto,
  GetPersonDto,
  MessageResponseDto,
  PersonApiFp,
  PersonControllerGet200Response,
  SendEmailDto,
  UnlockPersonDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponsePersonModel = PersonControllerGet200Response;
export type GetPersonModel = GetPersonDto;
export type MutateResponsePersonModel = MessageResponseDto;
export type CreatePersonModel = CreatePersonExtendedDto;
export type UpdatePersonModel = EditPersonExtendedDto;
export type DeletePersonModel = DeletePersonDto;
export type RegisterPersonModel = CreatePersonExtendedDto;
export type UnlockPersonModel = UnlockPersonDto;
export type BlockPersonModel = BlockPersonDto;

// Temp
export type SendEmailModel = SendEmailDto;
export interface UploadEmailImageModel {
  file: File
}

export interface CreatePersonModelExtension {
  person: CreatePersonModel;
  file: File;
}

export interface UpdatePersonModelExtension {
  person: UpdatePersonModel;
  file: File;
}

export const apiPersonFp = PersonApiFp(apiConfig);
export const getPersonController = apiPersonFp.personControllerGet;
export const getStaffPersonController = apiPersonFp.personControllerStaff;
export const createPersonController = apiPersonFp.personControllerCreate;
export const updatePersonController = apiPersonFp.personControllerEdit;
export const deletePersonController = apiPersonFp.personControllerDelete;
export const registerPersonController = apiPersonFp.personControllerRegister;
export const unlockPersonController = apiPersonFp.personControllerUnlock;
export const blockPersonController = apiPersonFp.personControllerBlock;

// Temp
export const apiSendEmailFp = BirthdayApiFp(apiConfig);
export const sendEmailController = apiSendEmailFp.birthdayControllerSendEmail;
export const uploadEmailImageController = apiSendEmailFp.birthdayControllerUploadImage;
export const claimBirthdayRewardController = apiSendEmailFp.birthdayClaimControllerClaim;

export const QueryKeyPerson = QueryKey.Person;
export const QueryKeyCustomer = QueryKey.Customer;
